// extracted by mini-css-extract-plugin
export default {"wrap":"image-with-preview_wrap__8186U"};